import { Button, Modal, Typography } from '@volvo/vcdk-react';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = {
  isLoading: boolean;
  onSuccess?: () => void;
};

const RemoveUnitsFleetModal: React.FC<Props> = ({ onSuccess, isLoading }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const resetModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button variant="primary" size="medium" onClick={openModal}>
        {t(($) => $.components.modal.remove_units_fleet_modal.button_remove)}
      </Button>
      {isOpen &&
        createPortal(
          <Modal open={isOpen} onClose={() => resetModal()} width={700} maxWidth="90%">
            <span slot="header">{t(($) => $.components.modal.remove_units_fleet_modal.title_remove)}</span>
            <div className="mb-6 flex flex-col gap-6">
              <Typography>{t(($) => $.components.modal.remove_units_fleet_modal.description)}</Typography>
              <Typography>{t(($) => $.components.modal.remove_units_fleet_modal.confirmation)}</Typography>
            </div>
            <span slot="modalFooter">
              <div className="flex gap-4">
                <Button variant="secondary" size="medium" onClick={() => resetModal()} disabled={isLoading}>
                  {t(($) => $.components.modal.remove_units_fleet_modal.cancel)}
                </Button>
                <Button
                  variant="primary"
                  size="medium"
                  onClick={() => onSuccess?.()}
                  disabled={isLoading}
                  loading={isLoading}
                >
                  {t(($) => $.components.modal.remove_units_fleet_modal.submit.create_fleet)}
                </Button>
              </div>
            </span>
          </Modal>,
          document.body
        )}
    </>
  );
};

export default withComponentErrorBoundary(RemoveUnitsFleetModal);
